




































































import { Component, Vue } from 'vue-property-decorator';
import { CompanyDetailsModule } from '@/store/modules/companyDetails'
import PageNames from '@/router/PageNames';
import ContactDto from '@/models/Contacts/ContactDto'
import ContactEdit from '@/components/Contacts/ContactEdit.vue';
import CompanyContactCreate from '@/components/Companies/CompanyContactCreate.vue';
import GiganautVue from '@/components/Shared/GiganautVue';
import ContactStatus from '@/components/Contacts/Display/ContactStatus.vue';

@Component({
  name: 'CompanyContactList',
  components: { ContactEdit, CompanyContactCreate, ContactStatus }
})
export default class extends GiganautVue {

    async created() {
        await CompanyDetailsModule.getContacts();
    }

    get loadingContacts() {
        return CompanyDetailsModule.loadingContacts;
    }

    get contacts() {
        return CompanyDetailsModule.contacts;
    }

    async navigateToContact(item: ContactDto) {
        const contactId = item.id;
        this.$router.push({ name: PageNames.AgencyContactDetails, params: { contactid: contactId } });
    }

    private search = '';
  
    private headers = [
        { text: 'First Name', value: 'person.firstName' },
        { text: 'Last Name', value: 'person.lastName' },
        { text: 'Job Title', value: 'jobTitle' },
        { text: 'Mobile Number' },
        { text: 'Email Address' },
        { text: 'Locations'},
        { text: 'Status'},
    ]
}
